<template>
  <el-input
    size="mini"
    class="r-input dark"
    :disabled="readonly"
    v-model="value"
    @change="change($event)"
    @mousedown.stop
  />
</template>

<script>
export default {
  props: ["readonly", "emitter", "ikey", "type", "getData", "putData"],
  data() {
    return {
      value: ""
    };
  },
  methods: {
    change(value) {
      this.value = value;
      this.update();
    },
    update() {
      if (this.ikey) this.putData(this.ikey, this.value);
      this.emitter.trigger("process");
    }
  },
  mounted() {
    this.value = this.getData(this.ikey);
  }
};
</script>

<style lang="scss" scoped>
.r-input {
  width: 60px;
}
</style>
